import style from './NotFound.styl';
import { Footer } from '@components';

export function NotFound() {
  return (
    <div className={style.title}>404 Not Found</div>
  );
}
